export default "__VITE_ASSET__1b5aef52__"